import * as moment from "moment";

export class CheckInData {
  name: string;
  checkIn: Date;
  checkOut: Date;


  public static ToTypeSafe(data: CheckInData): CheckInData {

    let checkInData = new CheckInData();
    checkInData.name = data.name;
    checkInData.checkIn = new Date(data.checkIn);
    if (data.checkOut) {
      checkInData.checkOut = new Date(data.checkOut);
    }
    else {
      checkInData.checkOut = null;
    }


    return checkInData;
  }

  get checkInAsLocalDateString(): string {
    return moment(this.checkIn).format("YYYY-MM-DD HH:mm");
  }

  get checkOutAsLocalDateString(): string {
    if (this.checkOut){
      return moment(this.checkOut).format("YYYY-MM-DD HH:mm");
    }
    return "";
  }
}
